interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
  
export const CustomTabPanel = ({children, value, index, ...other}: TabPanelProps) => {
    return (
        <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
        >
        {value === index && (
            <>
            {children}
            </>
        )}
        </div>
    );
}